// React
import { useContext } from "react"

// Components
import { BaseTable, Loading, TableHeader } from "components"

// Contexts
import { DataContext } from "../contexts"

// Form
import { useFormContext } from "react-hook-form"

// Icons
import { IoSendSharp } from "react-icons/io5"

// Types
import { FormType } from "../utils"

// Utils
import { convertNumber } from "utils"
import toast from "react-hot-toast"

export function DetailReturn(): JSX.Element {
  // Hooks
  const { detailreturn, datainvoice, onAddDetail } = useContext(DataContext)

  // Form
  const { formState: { disabled } } = useFormContext<FormType>()  

  return (
    <BaseTable>
      <TableHeader>
        <tr>
          <th></th>
          <th>QTY RETURNED</th>
          <th>QTY REFUNDED</th>
          <th>BACK DELIVERED</th>
          <th>UNIT</th>
          <th>ITEM CODE</th>
          <th>DESCRIPTION</th>
          <th>PRICE</th>
          <th>DISC (%)</th>
          <th>TOTAL</th>
          <th>TAX</th>
        </tr>
      </TableHeader>

      <tbody>
        {!detailreturn.length ? (
          <tr>
            <td colSpan={11}>
              <Loading errorText="No data available" />
            </td>
          </tr>
        ) : detailreturn.map((item, key) => {
          const qty_back_returned = item.quantity_return - item.qty_refunded
          let isDisabledRow: boolean = item.qty_refunded >= item.quantity_return
          let isDisabledButton: boolean= isDisabledRow === true
           
          return (
            <tr key={key} className={`${isDisabledRow && "text-error line-through"}`}>
              <td>
                {!disabled && (
                  <button
                    disabled={isDisabledButton}
                    className={`-rotate-90 ${isDisabledButton ? 'opacity-50':''}`}
                    onClick={() =>{ 
                      if(datainvoice.total_payment === 0){
                        return toast.error('No payment yet')
                      }
                      onAddDetail(item)
                    }}
                  >
                    <IoSendSharp/>
                  </button>
                )}
              </td>

              <td className="text-right">{convertNumber(item.quantity_return).intoNormalAmount}</td>
              <td className="text-right">{convertNumber(item.qty_refunded).intoNormalAmount}</td>
              <td className="text-right">{convertNumber(qty_back_returned).intoNormalAmount}</td>
              <td>{item.unit_sell_measure_name}</td>
              <td className="text-center">{item.product_barcode}</td>
              <td>{item.product_name}</td>
              <td className="text-right">{convertNumber(item.price_return).intoCurrency}</td>
              <td className="text-right">{convertNumber(item.discount_return).intoCurrency}%</td>
              <td className="text-right">{convertNumber(item.total_return).intoCurrency}</td>
              <td>{item.tax_name} ({item.tax_rate}%)</td>
            </tr>
          )
        })}
      </tbody>
    </BaseTable>
  )
}